const request = {}

request.createRequest = function (params) {
  return params
  // return {
  //   lastName: params.lastName,
  //   firstName: params.firstName,
  //   section: params.section,
  //   position: params.position,
  //   phoneNumberCountryId: params.phoneNumberCountryId,
  //   phoneNumber: params.phoneNumber,
  //   iconImgUrl: params.iconImgUrl
  // }
}
export default { request }
